import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiArrowRight } = FiIcons;

export default function LoginForm({ onLogin }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      onLogin(email);
      setIsLoading(false);
    }, 1500);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-3 ml-1">
          Email Address
        </label>
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="you@example.com"
          required
          className="input-field"
        />
      </div>

      <button 
        type="submit" 
        disabled={isLoading}
        className="btn btn-primary w-full py-5 space-x-3"
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-slate-950 border-t-transparent rounded-full animate-spin" />
        ) : (
          <>
            <span>Send Magic Link</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </>
        )}
      </button>
      
      <p className="text-center text-[10px] text-slate-600 font-bold uppercase tracking-widest">
        We'll email you a login link. No password needed.
      </p>
    </form>
  );
}